<h1 *ngIf="!addZones" ngif class="textS+" style="text-align: center; margin-top: 0px" mat-dialog-title>
  {{ regla.idRegla != 0 ? this.localiser.get("rules.editRuleTitle") : this.localiser.get("rules.newRuleTitle") }}
</h1>
<h1 *ngIf="addZones" class="textS+" style="text-align: center; margin-top: 0px" mat-dialog-title>
  {{ this.localiser.get("rules.zones.edit") }}
</h1>

<div *ngIf="!addZones" mat-dialog-content class="bodyForm">
  <div class="row rowForm">
    <div class="col-4">
      <h4 class="textS+">{{this.localiser.get("rules.name")}}</h4>
      <input [(ngModel)]="regla.nombre" type="text" class="inputWidth textS" style="width: 70%">
    </div>
  </div>

  <div class="row" style="margin-top: 32px">
    <div class="col-1">
      {{this.localiser.get("rules.weekday")}}
    </div>
    <div class="col-11">
      <div class="row">
        <div class="col-4">
          <div class="row">
            <div class="col">
              {{this.localiser.get("rules.segment.one")}}
            </div>
          </div>
          <div class="row">
            <div class="col-3">
              {{this.localiser.get("rules.min")}}
            </div>
            <div class="col-3">
              {{this.localiser.get("rules.max")}}
            </div>
            <div class="col-3">
              {{this.localiser.get("rules.segment.start")}}
            </div>
            <div class="col-3">
              {{this.localiser.get("rules.segment.end")}}
            </div>
          </div>
        </div>
        <div class="col-4">
          <div class="row">
            <div class="col">
              {{this.localiser.get("rules.segment.two")}}
            </div>
          </div>
          <div class="row">
            <div class="col-3">
              {{this.localiser.get("rules.min")}}
            </div>
            <div class="col-3">
              {{this.localiser.get("rules.max")}}
            </div>
            <div class="col-3">
              {{this.localiser.get("rules.segment.start")}}
            </div>
            <div class="col-3">
              {{this.localiser.get("rules.segment.end")}}
            </div>
          </div>
        </div>
        <div class="col-4">
          <div class="row">
            <div class="col">
              {{this.localiser.get("rules.segment.three")}}
            </div>
          </div>
          <div class="row">
            <div class="col-3">
              {{this.localiser.get("rules.min")}}
            </div>
            <div class="col-3">
              {{this.localiser.get("rules.max")}}
            </div>
            <div class="col-3">
              {{this.localiser.get("rules.segment.start")}}
            </div>
            <div class="col-3">
              {{this.localiser.get("rules.segment.end")}}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div *ngFor="let i of [0,1,2,3,4,5,6]" class="row" style="margin-top: 1%">
    <div class="col-1">
      {{ getDayOfWeekInText(i) }}
    </div>
    <div class="col-11">
      <div class="row">
        <div class="col-4" style="border-right: inset;">
          <div class="row">
            <div class="col-3">
              <input [(ngModel)]="regla.days_of_week[week[i]].tramos[0].min" type="number" class="inputWidth textS" style="width: 100%" min="0" max="100" appOnlyNumbers>
            </div>
            <div class="col-3">
              <input [(ngModel)]="regla.days_of_week[week[i]].tramos[0].max" type="number" class="inputWidth textS" style="width: 100%;" min="0" max="100" appOnlyNumbers>
            </div>
            <div class="col-3">
              <input [(ngModel)]="regla.days_of_week[week[i]].tramos[0].h_inicio" type="time" class="textS">
            </div>
            <div class="col-3">
              <input [(ngModel)]="regla.days_of_week[week[i]].tramos[0].h_fin" type="time" class="textS">
            </div>
          </div>
        </div>
        <div class="col-4" style="border-right: inset;">
          <div class="row">
            <div class="col-3">
              <input [(ngModel)]="regla.days_of_week[week[i]].tramos[1].min" type="number" class="inputWidth textS" style="width: 100%" min="0" max="100" appOnlyNumbers>
            </div>
            <div class="col-3">
              <input [(ngModel)]="regla.days_of_week[week[i]].tramos[1].max" type="number" class="inputWidth textS" style="width: 100%" min="0" max="100" appOnlyNumbers>
            </div>
            <div class="col-3">
              <input [(ngModel)]="regla.days_of_week[week[i]].tramos[1].h_inicio" type="time" class="textS">
            </div>
            <div class="col-3">
              <input [(ngModel)]="regla.days_of_week[week[i]].tramos[1].h_fin" type="time" class="textS">
            </div>
          </div>
        </div>
        <div class="col-4">
          <div class="row">
            <div class="col-3">
              <input [(ngModel)]="regla.days_of_week[week[i]].tramos[2].min" type="number" class="inputWidth textS" style="width: 100%" min="0" max="100" appOnlyNumbers>
            </div>
            <div class="col-3">
              <input [(ngModel)]="regla.days_of_week[week[i]].tramos[2].max" type="number" class="inputWidth textS" style="width: 100%" min="0" max="100" appOnlyNumbers>
            </div>
            <div class="col-3">
              <input [(ngModel)]="regla.days_of_week[week[i]].tramos[2].h_inicio" type="time" class="textS">
            </div>
            <div class="col-3">
              <input [(ngModel)]="regla.days_of_week[week[i]].tramos[2].h_fin" type="time" class="textS">
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="row" style="margin-top: 32px">
    <div class="col-1">
      {{this.localiser.get("rules.resto")}}
    </div>
    <div class="col-11">
      <div class="row">
        <div class="col-4">
          <div class="row">
            <div class="col-3">
              <!-- <input [(ngModel)]="regla.days_of_week[getDayOfWeekInText(i)].tramos[0].min" type="number" class="inputWidth textS" style="width: 100%" min="0" max="100" appOnlyNumbers> -->
              <input [(ngModel)]="regla['min_resto']" type="number" class="inputWidth textS" style="width: 100%" min="0" max="100" appOnlyNumbers>
            </div>
            <div class="col-3">
              <!-- <input [(ngModel)]="regla.days_of_week[getDayOfWeekInText(i)].tramos[0].max" type="number" class="inputWidth textS" style="width: 100%;" min="0" max="100" appOnlyNumbers> -->
              <input [(ngModel)]="regla['max_resto']" type="number" class="inputWidth textS" style="width: 100%" min="0" max="100" appOnlyNumbers>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="col-11">
      <div class="row">
        <div class="col">
          <div class="row">
          </div>
        </div>
      </div>
    </div> -->
  </div>
  <div style="margin-top: 4%">
    <h3 *ngFor="let error of this.errorsArray" class="textS" style="color: #FF0C41"><b>{{error}}</b></h3>
  </div>
</div>

<div *ngIf="addZones" mat-dialog-content class="bodyForm">
  <!-- <div *ngIf="this.zonasFueraDeReglaReal.length == 0 && this.zonasEnReglaReal.length == 0" class="row" style="height: 100%">
    <span style="width: 100%; display: flex; align-items: center; justify-content: center;">{{this.localiser.get("rules.zones.no_rules_available")}}</span>
  </div> -->
  <!-- <div *ngIf="this.zonasFueraDeReglaReal.length > 0 || this.zonasEnReglaReal.length > 0" class="row" style="height: 100%"> -->
  <div class="row" style="height: 100%">
    <div class="col" style="height: 100%; border-right: 2px solid">
      <h1 class="textM" style="text-align: center">{{this.localiser.get("rules.zones.zones_without_rules")}}</h1>

      <div class="row searcherDiv">
        <div class="col-10">
          <input [(ngModel)]="searcherZonasFueraDeRegla" type="text" class="centerVert textS+ searcherInput"
                placeholder="{{this.localiser.get('devices.searcher')}}" (input)="searcherZonasFueraDeReglaFunc()" maxlength="50">
        </div>

        <div class="col-2" style="margin: inherit">
          <span class="material-icons-outlined textXXM">
            search
          </span>
        </div>
      </div>

      <div class="luminariasListScroll">
        <div *ngFor="let zona of this.zonasFueraDeRegla; index as i" class="row luminariaBox">
          <div class="col-2">
            <span (click)="addZonaToRegla(zona)" class="material-icons-outlined buttonMapAdd textXM centerVert" style="cursor: pointer;">
                add_circle_outline
            </span>
          </div>
          <div class="luminariaRow col-8">
            <h6 class="textS+" style="text-decoration: underline; margin: 1% auto">{{this.localiser.get('devices.zone')}}: {{zona.nombre}}</h6>
            <h6 class="textS" style="margin: 1% auto">{{this.localiser.get('parameters.parameter.zone')}}: {{zona.idPorProyecto}}</h6>
            <h6 *ngIf="zona.regla != this.regla.idRegla && this.getRuleField(zona.regla, 'nombre') != undefined" class="textS" style="margin: 1% auto">{{this.localiser.get('rules.zones.assigned_rule')}}: {{this.localiser.get('rules.id')}} {{zona.regla}} - {{this.getRuleField(zona.regla, 'nombre')}}</h6>
          </div>
        </div>
      </div>
    </div>

    <div class="col" style="height: 100%">
      <h1 class="textM" style="text-align: center">{{this.localiser.get("rules.zones.zones_in_rule")}}</h1>

      <div class="row searcherDiv">
        <div class="col-10">
          <input [(ngModel)]="searcherZonasEnRegla" type="text" class="centerVert textS+ searcherInput"
                placeholder="{{this.localiser.get('devices.searcher')}}" (input)="searcherZonasEnReglaFunc()" maxlength="50">
        </div>

        <div class="col-2" style="margin: inherit">
          <span class="material-icons-outlined textXXM">
            search
          </span>
        </div>
      </div>

      <div class="luminariasListScroll">

        <div *ngFor="let zona of this.zonasEnRegla; index as i" class="row luminariaBox">
          <div class="col-2">
            <span (click)="removeZonaFromRegla(zona)" class="material-icons-outlined buttonMapRm textXM centerVert" style="cursor: pointer;">
                remove_circle_outline
            </span>
          </div>
          <div class="luminariaRow col-8">
            <!-- <h6 class="textS+" style="text-decoration: underline; margin: 1% auto">{{zona}}</h6> -->
            <h6 class="textS+" style="text-decoration: underline; margin: 1% auto">{{this.localiser.get('devices.zone')}}: {{zona.nombre}}</h6>
            <h6 class="textS" style="margin: 1% auto">{{this.localiser.get('parameters.parameter.zone')}}: {{zona.idPorProyecto}}</h6>
            <h6 class="textS" style="margin: 1% auto">{{this.localiser.get('rules.confirmed_nodes')}}: {{zona.nodos_confirmados}}/{{zona.nodos_total}}</h6>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div mat-dialog-actions>
  <div class="col" style="text-align: center">
    <button class="customButtonColor textS" mat-button
      (click)="onCancelClick()">{{this.localiser.get("button.close")}}</button>
  </div>
  <div class="col" style="text-align: center">
    <button class="customButtonColor textS" mat-button
      (click)="copyWeek()">{{this.localiser.get("rules.segments.copy")}}</button>
  </div>
  <div class="col" style="text-align: center">
    <button class="customButtonColor textS" [ngClass]="{customButtonColorWarning: !checkCreationRegla()}"
      [disabled]="creating" mat-button (click)="openZonesModal()">
      {{ addZones ? this.localiser.get("rules.edit.parts") : this.localiser.get("rules.zones.edit") }}
    </button>
  </div>
  <div class="col" style="text-align: center">
    <button *ngIf="!addZones" class="customButtonColor textS" [ngClass]="{customButtonColorWarning: !checkCreationRegla()}"
      [disabled]="creating" mat-button (click)="tryCreateRegla()">
      {{ regla.idRegla != 0 ? this.localiser.get("button.update") : this.localiser.get("button.create") }}
    </button>
    <button *ngIf="addZones" class="customButtonColor textS" [ngClass]="{customButtonColorWarning: !checkCreationRegla()}"
      [disabled]="creating" mat-button (click)="tryCreateRegla()">
      {{ this.localiser.get("button.apply") }}
    </button>
  </div>
</div>
